import { BRAND } from "../data/content";

// Non-blocking cinematic loader. Self-dismisses via CSS animation.
export default function Loader() {
  return (
    <div className="loader-overlay" data-testid="loader">
      <div className="loader-scan" aria-hidden />
      <h1 className="loader-title font-display chrome-text text-4xl md:text-6xl tracking-[0.06em]">
        {BRAND.name}
      </h1>
      <p className="loader-sub track-label text-white/50 mt-5">{BRAND.phrase}</p>
      <div className="loader-wave" aria-hidden>
        {Array.from({ length: 22 }).map((_, i) => (
          <span key={i} style={{ animationDelay: `${i * 0.05}s` }} />
        ))}
      </div>
    </div>
  );
}
